import React from 'react'

const NotificationMainPage = () => {
  return (
    <div>NotificationMainPage</div>
  )
}

export default NotificationMainPage